import { z } from 'zod';
// 캠페인 상품 슬롯 스키마/타입은 시딩 도메인 공통 — get-seeding-me-recruitment 정의 재사용
import {
  CampaignGoodsSlotSchema,
  SeedingContentChannelSchema,
} from './get-seeding-me-recruitment.dto';

export type { CampaignGoodsItem, CampaignGoodsSlot } from './get-seeding-me-recruitment.dto';

export const RecruitmentSortSchema = z.enum(['LATEST', 'SELECTION_PROBABILITY', 'DEADLINE_SOON']);
export type RecruitmentSort = z.infer<typeof RecruitmentSortSchema>;

export const GetRecruitmentCampaignsServiceRequestSchema = z
  .object({
    categoryNo: z.string().optional(),
    likedBrandOnly: z.boolean().optional(),
    sort: RecruitmentSortSchema.optional(),
    page: z.number().int().min(1).max(10000).optional(),
    size: z.number().int().min(1).max(100).optional(),
  })
  .describe('GetRecruitmentCampaignsServiceRequestSchema');

export type GetRecruitmentCampaignsServiceRequest = z.infer<
  typeof GetRecruitmentCampaignsServiceRequestSchema
>;

const RecruitmentCampaignItemSchema = z
  .object({
    campaignId: z.number(),
    brandId: z.string(),
    brandName: z.string(),
    goodsName: z.string(),
    goodsImage: z.string(),
    goodsPrice: z.number(),
    recruitmentEndAt: z.string(),
    snsChannels: z.array(SeedingContentChannelSchema),
    goodsSlots: z.array(CampaignGoodsSlotSchema),
  })
  .describe('RecruitmentCampaignItemSchema');

export type RecruitmentCampaignItem = z.infer<typeof RecruitmentCampaignItemSchema>;

export const GetRecruitmentCampaignsServiceResponseSchema = z
  .object({
    list: z.array(RecruitmentCampaignItemSchema),
    pagination: z.object({
      page: z.number(),
      size: z.number(),
      hasNext: z.boolean(),
      nextPage: z.number().nullable(),
    }),
  })
  .describe('GetRecruitmentCampaignsServiceResponseSchema');

export type GetRecruitmentCampaignsServiceResponse = z.infer<
  typeof GetRecruitmentCampaignsServiceResponseSchema
>;
